"use client";
import { forwardRef } from "react";
import { useLinkComponent } from "../../lib/context/config/context";

const Link = forwardRef(function Link(props: any, ref) {
  const Component = useLinkComponent();
  return <Component {...props} ref={ref} />;
});
export default Link;
